import { LineLayout, SymbolLayout } from "mapbox-gl";
import { IconType } from "../icons";

// cannot change color for icons unless they are in SDF format
// so we make separate icon layout per arrow color
export const trajectoryArrowLayout: SymbolLayout = {
    "symbol-placement": "line-center",
    "symbol-spacing": 1,
    "icon-allow-overlap": true,
    "icon-image": IconType.THIN_ARROW,
    "icon-size": 0.1,
    "icon-rotate": -90,
    visibility: "visible",
};

export const hermesArrowLayout: SymbolLayout = {
    "symbol-placement": "line-center",
    "symbol-spacing": 2,
    "icon-allow-overlap": true,
    "icon-image": ["get", "icon_image"],
    "icon-size": 0.1,
    "icon-rotate": -90,
    visibility: "visible",
};

export const variableSymbolLayout = (iconType: IconType): SymbolLayout => {
    let icon_size = 0.15;
    if ([IconType.SQUARE_ORANGE, IconType.SQUARE_RED].includes(iconType)) {
        icon_size = 0.1;
    }
    return {
        "symbol-placement": "point",
        "icon-allow-overlap": true,
        "icon-image": iconType,
        "icon-size": icon_size,
        visibility: "visible",
    } as SymbolLayout;
};

export const carLayout: SymbolLayout = {
    "symbol-placement": "point",
    "icon-allow-overlap": true,
    "icon-image": IconType.CAR,
    "icon-size": 0.12,
    visibility: "visible",
};

export const roundedLineLayout: LineLayout = {
    "line-join": "round",
    "line-cap": "round",
};
